import { type SuretyEntityIdMap } from "../types";

export const commentsQueryKey = <T extends keyof SuretyEntityIdMap>(
	type: T,
	id?: SuretyEntityIdMap[T],
) => ["comments", type, id] as const;

export const createCommentMutationKey = <T extends keyof SuretyEntityIdMap>(
	type: T,
	id: SuretyEntityIdMap[T],
) => ["createComment", type, id] as const;
